import { createFileRoute } from "@tanstack/react-router"

// Import the existing manage page component
import Manage from "@/features/jobs/manage/components/manage-list-page"

export const Route = createFileRoute("/_app/manage")({
  component: ManagePage
})

function ManagePage() {
  return <Manage />
}
